const openedTabs = new Map();   // key -> WindowProxy（keyを渡したタブのみ再利用対象）

const esc = (s) => String(s).replace(/[&<>"']/g, (c) =>
  ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

const html = (title, body) => `<!DOCTYPE html><html><head>
<meta charset="UTF-8"><title>${esc(title)}</title>
<style>html,body{margin:0;height:100%;overflow:hidden}
iframe{width:100%;height:100%;border:none}
.l{display:flex;height:100%;align-items:center;justify-content:center;font-family:sans-serif}</style>
</head><body>${body}</body></html>`;

/**
 * PDFを別タブで開く
 * @param {String} [key]  - タブ再利用キー。同一keyの再押下は既存タブを前面化（ベストエフォート）。
 *                          省略時（未保存ファイル等）は再利用せず毎回新タブ
 * @param {String} name   - ファイル名（タブタイトルに表示。エスケープされる）
 * @param {Function} loader - () => Promise<blobUrl> PDF取得処理(呼び出し元でAPIを選ぶ)
 */
export function openPdfInNewTab({ key, name, loader }) {
  if (key) {
    const exist = openedTabs.get(key);
    if (exist && !exist.closed) { exist.focus(); return Promise.resolve(); } // 前面化はブラウザ依存(§5)
    if (exist) openedTabs.delete(key); // 閉じ済みタブの残骸を掃除
  }

  // ★クリックの同期文脈でタブを確保する（awaitの後ではブロックされる）
  const tab = window.open('', '_blank');
  if (!tab) return Promise.reject({ code: 'POPUP_BLOCKED' });
  if (key) openedTabs.set(key, tab);
  tab.document.write(html(name, `<div class="l">Loading…</div>`));
  tab.document.close();

  // ★Promise.resolve()起点にすることで、loaderの同期throw（toBlob失敗等）も必ずrejectへ落とす
  return Promise.resolve()
    .then(loader)
    .then((src) => {
      if (tab.closed) { // ロード中にユーザーがタブを閉じた
        window.URL.revokeObjectURL(src);
        if (key) openedTabs.delete(key);
        return;
      }
      tab.document.open(); // ※これでWindow/Document上のイベントリスナーは全消去される
      tab.document.write(html(name, `<iframe src="${src}" type="application/pdf"></iframe>`));
      tab.document.close();
      // PDFタブが閉じられたらBlob URLを解放しMapを掃除する。
      // ★必ず最終document.open()の「後」に張ること（前に張るとopen()で消される）
      tab.addEventListener('pagehide', () => {
        window.URL.revokeObjectURL(src);
        if (key) openedTabs.delete(key);
      });
    })
    .catch((err) => {
      if (!tab.closed) tab.close();
      if (key) openedTabs.delete(key);
      throw err;
    });
}
